import {api, handleApiError, ServiceResponse} from "../ApiClient";
import {Caddie} from "./CaddieService";
import {User} from "./UserService";

export interface LeaderboardResource {
    rows: {
        caddie: Caddie
        user: User

        roundCount: number
        reviewCount: number

        overallRating: number
    }[]
}

export interface GetLeaderboardResponse extends ServiceResponse{
    leaderboard?: LeaderboardResource
}

export const LeaderboardService = () => {

    const get = (clubId: string): Promise<GetLeaderboardResponse> =>
        api.get<LeaderboardResource>(`/api/1/reviews-leaderboard?forClub=${clubId}`)
            .then((resp) => {
                if (resp && resp.status === 200) {
                    return {
                        leaderboard: resp.data
                    }
                }

                return handleApiError(resp)
            })
            .catch(handleApiError)

    return {
        getLeaderboard: get,
    }
}
